import React, { useState, useEffect } from "react";
import { trivvyFileTypeCheck, uploadPreview } from "../../../utils/constants";
import {
  BiCopy,
  BiLogoGoogle,
  BiLogoLinkedin,
  BiLogoMicrosoft,
  BiLogoMicrosoftTeams,
  BiLogoSlack,
  BiLogoWhatsapp,
  BiMailSend,
} from "react-icons/bi";
import { LuUploadCloud } from "react-icons/lu";
import * as actionCreators from "../../../modules/actions";
import { connect } from "react-redux";

import ReactTooltip from "react-tooltip";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Popover,
  PopoverHeader,
  PopoverBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Label,
} from "reactstrap";
import SlackSharePopup from "../../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../../components/SlackAndTeamsPopups/TeamsSharePopup";
import { baseUrl } from "../../../utils/constants";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select/lib/Select";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import { data } from "jquery";
import {
  minPlanLimitCheck,
  TRIVIA_LIB_PRIVACY_OPTIONS,
  TRIVVY_LANGUAGES,
} from "../data";
import CheckBox from "rc-checkbox";
import withLoading from "../../../hoc/Loading/Loading";
import moment from "moment";
import SupportedLanguagesText from "../../../components/Trivvy/SupportedLanguagesText";
import "./CreateTrivia/createTrivia.css";
import "./upload-document-bwai.css";

function UploadLibraryModal({
  open,
  onClose,
  onUploadSuccess,
  isToolkit = true,
  user,
  setCreateLibraryLoader,
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [privacy, setPrivacy] = useState("PRIVATE");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [webUrl, setWebUrl] = useState("");
  const [text, setText] = useState("");
  const [librarySourceType, setLibrarySourceType] = useState(1);
  const [name, setName] = useState("");
  const [isGenerateSummary, setIsGenerateSummary] = useState(false);
  const [alsoTranslate, setAlsoTranslate] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const trivvyPlanType =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType;

  const isAdmin = user.profile && user.profile.role && user.profile.role.toLocaleLowerCase() === 'admin';

  const formatSelectedUsers = (data) => {
    const d = data.emailUsers.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
        };
      } else if (e) {
        let name =
        e.firstName && e.firstName.length > 0 ? e.firstName : e.lastName && e.lastName.length > 0 ? e.lastName : e.email
        return { label: `${name}`, value: e._id || e.userId, permissions: 0 };
      }
    });

    return d;
  };

  const validate = () => {
    if (privacy && uploadedFile && uploadedFile.file) {
      if (
        !uploadedFile.file.type.indexOf("csv") >= 0 &&
        (uploadedFile.file.type.indexOf("pdf") >= 0 ||
          uploadedFile.file.type.indexOf("word") >= 0 ||
          uploadedFile.file.type.indexOf("text") >= 0)
      ) {
        return true;
      } else {
        toastContainer("Please upload WORD/PDF/TEXT files.", "error");

        return false;
      }
    } else {
      return false;
    }
  };

  const getUserList = () => {
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersData(response.data.data);
        const users = formatSelectedUsers(response.data.data);

        setUsersList(users);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserList();
  }, []);

  const fileSelectedHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (trivvyFileTypeCheck(file.type)) {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          datetime: Date.now().toString(),
          // blob: URL.createObjectURL(file),
          preview: URL.createObjectURL(file),
        };
        setUploadedFile(uploadPreview(obj));
      } else {
        toastContainer("Please upload Pdf or Doc or Txt file.", "error");
      }
    }
  };

  // Add drag and drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (trivvyFileTypeCheck(file.type)) {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          datetime: Date.now().toString(),
          preview: URL.createObjectURL(file),
        };
        setUploadedFile(uploadPreview(obj));
      } else {
        toastContainer("Please upload Pdf or Doc or Txt file.", "error");
      }
    }
  };

  const handleOptionChange = (val) => {
    setPrivacy(val.value);
  };

  const renderUploadPreview = () => {
    let photo = uploadedFile;
    let { preview, size, name } = photo;
    preview = preview != null && preview != undefined ? preview : photo.url;
    let mb = 1024 * 1024;
    let file_size =
      size >= mb
        ? `${(size / mb).toFixed(2)} KB`
        : `${(size / 1024).toFixed(2)} KB`;
    
    return (
      <div className="bwai_file_tile">
        {/* PDF Icon */}
        <div className="bwai_file_tile_chip">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="12" y1="18" x2="12" y2="12" />
            <line x1="9" y1="15" x2="15" y2="15" />
          </svg>
        </div>

        {/* File Name */}
        <div className="bwai_file_tile_body">
          <div className="bwai_file_tile_name">{name}</div>
          <div className="bwai_file_tile_size">{file_size}</div>
        </div>

        {/* Delete Icon */}
        <button
          className="bwai_file_tile_remove"
          type="button"
          aria-label="Remove file"
          onClick={(e) => {
            e.stopPropagation();
            setUploadedFile(null);
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
          </svg>
        </button>
      </div>
    );
  };

  const callApiToSaveData = () => {
    // Validation
    if (librarySourceType === 1 && !uploadedFile) {
      toastContainer("Please upload a file.", "error");
      return;
    }
    
    if (librarySourceType === 0 && !webUrl) {
      toastContainer("Please enter a website URL.", "error");
      return;
    }
    
    if (librarySourceType === 2 && !text) {
      toastContainer("Please enter custom text.", "error");
      return;
    }

    const users_share = selectedUsers.map((itm) => {
      const user = usersData.find((x) => x._id == itm.value);

      if (user) {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user._id,
          date: new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
        };
      }
    });

    const payload = {
      selectedUsers: users_share,
      status: privacy,
      organizationName: user.profile.organizationId.name,
      webUrl,
      librarySourceType,
      text,
      name: name
        ? name
        : librarySourceType == 1
        ? uploadedFile.name
        : librarySourceType == 0
        ? webUrl.match(/https?:\/\/(?:www\.)?([^\/]+)/)[1]
        : `Custom text ${moment().format("MM/DD/YYYY")}`,
      isGenerateSummary,
      languages: alsoTranslate ? selectedLanguages.map(lang => lang.value) : [],
    };

    const triviaForm = new FormData();

    if (uploadedFile) {
      triviaForm.append("document", uploadedFile.file);
    }

    triviaForm.append("payload", JSON.stringify(payload));

    const loaderApiData = {
      triviaForm: triviaForm,
      payload: payload,
      cb: onUploadSuccess,
      content:
        librarySourceType == 0
          ? webUrl
          : librarySourceType == 1
          ? uploadedFile.name
          : librarySourceType == 2
          ? text
          : "",
      contentType:
        librarySourceType == 0
          ? "LINK"
          : librarySourceType == 1
          ? "TEXT"
          : librarySourceType == 2
          ? "TEXT"
          : "",
    };

    setCreateLibraryLoader({
      loaderApiData,
      display: true,
      minimize: false,
    });

    onClose();
  };
  /* Webpage (0) and Custom Text (2) dropped per Sonya — they don't work here.
     Kept as a list so another source type can be added back later. */
  const uploadOptions = [{ label: "Upload File", value: 1 }];
    // { label: "Webpage", value: 0 },
    // { label: "Custom Text", value: 2 },
  
  const privacyOptions = [
    ...TRIVIA_LIB_PRIVACY_OPTIONS.filter(opt => opt.value !== 'CUSTOM'),
    ...(isAdmin ? [{ label: "Only Admins", value: "ADMIN" }] : [])
  ];
  
  return (
    <div>
      <Modal isOpen={open} size="lg" className="bwai-modal bwai_upload_doc">
        <ModalHeader className="bwai_modal_header" toggle={onClose}>
          <span className="bwai_title_chip is-tint-orange">
            <LuUploadCloud />
          </span>
          <span className="bwai_title_block">
            <span className="bwai_title_text">Upload Document</span>
            <span className="bwai_title_sub">
              Add a document to your library. Supported formats: PDF, DOC, TXT.
            </span>
          </span>
        </ModalHeader>
        <ModalBody className="p-3">
          {/* Name Field */}
          <div className="mb-3">
            <Label className="bwai_label_caps">
              Name <span className="bwai_label_cap_note">(optional)</span>
            </Label>
            <Input
              className="bwai_field"
              placeholder="Please enter a name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          {/* Data Source Field */}
          <div className="mb-3">
            <Label className="bwai_label_caps">
              Data Source <span className="bwai_required_mark">*</span>
            </Label>
            <Select
              value={uploadOptions.find(opt => opt.value === librarySourceType)}
              onChange={(e) => {
                if (e) {
                  setLibrarySourceType(e.value);
                } else {
                  setLibrarySourceType(null);
                }
              }}
              options={uploadOptions}
              placeholder="Select type of data upload..."
            />
          </div>

          {/* Document Upload Area - Upload File */}
          {librarySourceType === 1 ? (
            <div className="mb-3 bwai_card">
              <Label className="bwai_label_caps">Document</Label>
              <SupportedLanguagesText />

              {uploadedFile ? (
                <>
                  {renderUploadPreview()}
                  <div style={{ textAlign: 'left' }}>
                    <span
                      className="bwai_choose_file is-orange"
                      onClick={() => document.getElementById('profile-pic-file-input').click()}
                    >
                      Upload a different file
                    </span>
                  </div>
                </>
              ) : (
                <div
                  className="bwai_dropzone"
                  onClick={() => document.getElementById('profile-pic-file-input').click()}
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <LuUploadCloud className="bwai_dropzone_icon" />
                  <div>
                    Drop your file here, or{' '}
                    <span className="bwai_choose_file is-orange">browse</span>
                  </div>
                  <div className="bwai_dropzone_hint">
                    PDF, DOC, or TXT up to 10MB
                  </div>
                </div>
              )}

              <input
                id="profile-pic-file-input"
                onChange={fileSelectedHandler}
                type="file"
                accept=".pdf,.doc,.docx,.txt"
                style={{ display: 'none' }}
              />
            </div>
          ) : librarySourceType === 0 ? (
            <div className="mb-3">
              <Label className="bwai_label_caps">
                Website Url <span className="bwai_required_mark">*</span>
              </Label>
              <Input
                className="bwai_field"
                onChange={(e) => {
                  setWebUrl(e.target.value);
                }}
                value={webUrl}
                placeholder="Enter website url"
              />
            </div>
          ) : librarySourceType === 2 ? (
            <div className="mb-3">
              <Label className="bwai_label_caps">
                Custom Text <span className="bwai_required_mark">*</span>
              </Label>
              <textarea
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                }}
                rows={6}
                className="w-100 bwai_textarea"
                placeholder="Enter text for generating questions"
              />
            </div>
          ) : (
            ""
          )}

          {/* Category/Privacy Section */}
          <div className="mb-3">
            <Label className="bwai_label_caps">Privacy</Label>
            <Select
              value={privacyOptions.find(opt => opt.value === privacy)}
              onChange={(val) => {
                handleOptionChange(val);
              }}
              options={privacyOptions}
              placeholder="Select a privacy"
            />

            {privacy === "CUSTOM" && (
              <div className="mt-2">
                <Select
                  isMulti={true}
                  multi={true}
                  name="user-select"
                  placeholder="Select users to share this quiz with"
                  value={selectedUsers.length > 0 ? selectedUsers : ""}
                  options={usersList}
                  onChange={(itm) => setSelectedUsers(itm)}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            )}
          </div>

          {/* Translate Section */}
          {/* {minPlanLimitCheck(trivvyPlanType, "003") && (
            <div className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <CheckBox
                  checked={alsoTranslate}
                  onChange={(e) => {
                    setAlsoTranslate(e.target.checked);
                  }}
                  style={{
                    marginRight: '8px',
                    accentColor: '#3b82f6',
                  }}
                />
                <Label 
                  className="mb-0" 
                  style={{ 
                    fontSize: '14px', 
                    fontWeight: '500', 
                    color: '#374151',
                    cursor: 'pointer'
                  }}
                  onClick={() => setAlsoTranslate(!alsoTranslate)}
                >
                  Translate
                </Label>
              </div>
              {alsoTranslate && (
                <div>
                  <Label style={{ fontSize: '14px', fontWeight: '400', color: '#6b7280', marginBottom: '6px' }}>
                    Select language
                  </Label>
                  <Select
                    isMulti={true}
                    multi={true}
                    name="language-select"
                    placeholder="Select languages to translate"
                    value={selectedLanguages}
                    options={TRIVVY_LANGUAGES}
                    onChange={(values) => {
                      setSelectedLanguages(values);
                    }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
              )}
            </div>
          )} */}

          {/* Generate Summary Section */}
          <div className="mb-3">
            <label className="bwai_never_show">
              <CheckBox
                checked={isGenerateSummary}
                onChange={(e) => {
                  setIsGenerateSummary(e.target.checked);
                }}
              />
              <span className="bwai_never_show_text">Generate summary</span>
            </label>
          </div>
        </ModalBody>
        <ModalFooter className="bwai_popup_footer">
          <Button className="bwai_btn_link" color="link" onClick={onClose}>
            Cancel
          </Button>
          <Button className="bwai_btn_black" onClick={callApiToSaveData}>
            <LuUploadCloud />
            Upload Document
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCreateLibraryLoader: (data) =>
      dispatch(actionCreators.setCreateLibraryLoader(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLoading(UploadLibraryModal, axios));
